/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".bg-clr-yellow[_ngcontent-%COMP%]{background-color:#ffb822!important;color:#fff!important}.bg-clr-yellow[_ngcontent-%COMP%]   .image-hover-wear[_ngcontent-%COMP%]{filter:invert(4.9) sepia(4) saturate(3) hue-rotate(952deg)!important}\n/*# sourceMappingURL=my-wearables-calender.component.css.map*/"];
export { styles as styles };
